export default "__VITE_ASSET__BuVGM9fo__"